export default [
  {
    name: 'focus', // crssbrowser autofocus
    directive: {
      inserted: function(el) {
        el.focus();
      },
    },
  },
  {
    name: 'maxLengthForDateAutocomplete',
    directive: {
      bind(el, binding, vnode) {
        const handler = function() {
          if (!el.value) return;

          if (el.value.length === 4) {
            el.value = el.value.slice(2, 4);
            vnode.elm.dispatchEvent(new CustomEvent('input'));
          } else if (el.value.length > 2) {
            el.value = el.value.slice(0, 2);
            vnode.elm.dispatchEvent(new CustomEvent('input'));
          }
        };

        el.addEventListener('input', handler);
        el.$destroy = () => el.removeEventListener('input', handler);
      },
      unbind(el) {
        el.$destroy();
      },
    },
  },
  {
    name: 'maxLength',
    directive: {
      bind(el, binding, vnode) {
        const handler = function() {
          if (!el.value) return;

          if (el.value.length > binding.value) {
            el.value = el.value.slice(0, binding.value);
            vnode.elm.dispatchEvent(new CustomEvent('input'));
          }
        };

        el.addEventListener('input', handler);
        el.$destroy = () => el.removeEventListener('input', handler);
      },
      unbind(el) {
        el.$destroy();
      },
    },
  },
  {
    name: 'replace',
    directive: {
      bind(el, binding, vnode) {
        const handler = function() {
          if (!el.value) return;
          if (!binding.value.test(el.value)) return;

          el.value = el.value.replace(binding.value, '');
          vnode.elm.dispatchEvent(new CustomEvent('input'));
        };

        el.addEventListener('input', handler);
        el.$destroy = () => el.removeEventListener('input', handler);
      },
      unbind(el) {
        el.$destroy();
      },
    },
  },
  {
    name: 'regexp',
    directive: {
      bind(el, binding, vnode) {
        const handler = function() {
          if (!el.value) return;

          if (!binding.value.test(el.value)) {
            el.value = el.value.slice(0, -1);
            vnode.elm.dispatchEvent(new CustomEvent('input'));
          }
        };

        el.addEventListener('input', handler);
        el.$destroy = () => el.removeEventListener('input', handler);
      },
      unbind(el) {
        el.$destroy();
      },
    },
  },
  {
    name: 'textareasize',
    directive: {
      bind(el, binding, vnode) {
        const handler = () => {
          const outerHeight = parseInt(window.getComputedStyle(el).height, 10);
          const diff = outerHeight - el.clientHeight;

          el.style.height = 'inherit';
          el.style.height = Math.max(el.scrollHeight, el.scrollHeight + diff) + 'px';
        };

        el.addEventListener('input', handler);
        el.$destroy = () => el.removeEventListener('input', handler);
      },
      inserted(el, binding, vnode) {
        vnode.elm.dispatchEvent(new CustomEvent('input'));
      },
      update(el, binding, vnode) {
        vnode.elm.dispatchEvent(new CustomEvent('input'));
      },
      unbind(el) {
        el.$destroy();
      },
    },
  },
];
